import { initSentryBrowser } from '@nrx/error-tracking-web';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app.js';
import './index.css';

// Access-landing app — fully unauthenticated.
// No PortalAuthProvider, no Cognito pool wiring.
// Contrast with provider-portal/src/main.tsx which wraps in <PortalAuthProvider>.
// Sentry must initialise before the app renders (mirrors the backend instrument-first rule).
initSentryBrowser({
  dsn: import.meta.env['VITE_SENTRY_DSN'],
  environment: import.meta.env['VITE_SENTRY_ENVIRONMENT'],
  release: import.meta.env['VITE_SENTRY_RELEASE'],
  app: 'access-landing',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
